import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions, Headers } from '@angular/http';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

import { Vehicle } from './vehicle';

@Injectable()
export class VehicleService{
  private baseUrl: string = 'https://swapi.co/api';
  constructor(private http: Http) {
  }

  getAll(): Observable<Vehicle[]> {
    let vehicle$ = this.http
      .get(`${this.baseUrl}/vehicles`, { headers: this.getHeaders()})
      .map(mapVehicles)
      .catch(handleError);
      return vehicle$;
  }

  private getHeaders(){
    let headers = new Headers();
    headers.append('Accept', 'application/json');
    return headers;
  }
  get(id: number): Observable<Vehicle> {
    let vehicle$ = this.http
      .get(`${this.baseUrl}/vehicles/${id}`, {headers: this.getHeaders()})
      .map(mapVehicle)
      .catch(handleError);
      return vehicle$;
  }

  save(vehicle: Vehicle) : Observable<Response>{
    // this won't actually work because the StarWars API doesn't 
    // is read-only. But it would look like this:
    return this
      .http
      .put(`${this.baseUrl}/vehicles/${vehicle.id}`, 
            JSON.stringify(vehicle),
            {headers: this.getHeaders()});
  }

}

function mapVehicles(response:Response): Vehicle[]{
  //throw new Error('ups! Force choke!');

  // The response of the API has a results
  // property with the actual results
  return response.json().results.map(toVehicle);
}

function toVehicle(r:any): Vehicle{
  let vehicle = <Vehicle>({
    id: extractId(r),
    name: r.name,
    model: r.model,
    manufacturer: r.manufacturer,
    crew: Number.parseInt(r.crew),
  });
  console.log('Parsed vehicle:', vehicle);
  return vehicle;
}

// to avoid breaking the rest of our app
// I extract the id from the person url
function extractId(vehicleData: any) {
  let extractedId: any = vehicleData.url.replace('https://swapi.co/api/vehicles/','').replace('/','');
  return parseInt(extractedId);
}

function mapVehicle(response:Response): Vehicle {
   // toPerson looks just like in the previous example
   return toVehicle(response.json());
}

// this could also be a private method of the component class
function handleError (error: any) {
  // log error
  // could be something more sofisticated
  let errorMsg: any = error.message || `Yikes! There was a problem with our hyperdrive device and we couldn't retrieve your data!`
  console.error(errorMsg);

  // throw an application level error
  return Observable.throw(errorMsg);
}


// WEBPACK FOOTER //
// ./src/app/vehicle.service.ts